exports.ByNewStatus = {
  draft: { oldStatus: 0, newStatus: 'draft' },
  review: { oldStatus: 0, newStatus: 'review' },
  published: { oldStatus: 1, newStatus: 'published' },
  final: { oldStatus: 1, newStatus: 'final' }
};

exports.ByOldStatus = {
  0: { newStatuses: ['draft', 'review'], oldStatus: 0 },
  1: { newStatuses: ['published', 'final'], oldStatus: 1 }
};
